import { useLocation, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { singlePagesConst } from "../constants/single-pages";
import { pagesConst } from "../constants/pages";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

type SearchResult = {
  title: string;
  path: string;
  matchIn: "title" | "content";
};

const SearchPage = () => {
  const query = useQuery();
  const q = query.get("q") || "";
  const [results, setResults] = useState<SearchResult[]>([]);

  useEffect(() => {
    const lowerQ = q.toLowerCase();

    const pageResults: SearchResult[] = pagesConst
      .filter((page) => page.title.toLowerCase().includes(lowerQ))
      .map((page) => ({
        title: page.title,
        path: page.path,
        matchIn: "title",
      }));

    const singlePageResults: SearchResult[] = singlePagesConst
      .filter(
        (page) => page.title.toLowerCase().includes(lowerQ) || (page.contentSearch && page.contentSearch.toLowerCase().includes(lowerQ))
      )
      .map((page) => {
        const matchIn: "title" | "content" = page.title.toLowerCase().includes(lowerQ) ? "title" : "content";

        return {
          title: page.title,
          path: page.path,
          matchIn,
        };
      });

    setResults([...pageResults, ...singlePageResults]);
  }, [q]);

  return (
    <div className="container search-results padding-top">
      <h2>Search result: "{q}"</h2>
      {results.length > 0 ? (
        <ul>
          {results.map((page, idx) => (
            <li key={idx}>
              <Link to={page.path}>{page.title}</Link>
            </li>
          ))}
        </ul>
      ) : (
        <p>Nothing there.</p>
      )}
    </div>
  );
};

export default SearchPage;
